/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Repeater/view.blocks to change it.
import "DesignSystem/Fonts/Inter-200.css"
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import * as fromFlow from 'Simple/Flow'
import ArrowRight from 'DesignSystem/Svgs/ArrowRight/index'
import ArrowsDown from 'DesignSystem/Svgs/ArrowsDown/index'
import Check from 'DesignSystem/Svgs/Check/index'
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Repeater({
  children,
  viewPath = "/DesignSystem/Repeater",
  marginTop = 8,
  onClick,
  isReminder,
  label = "",
  text = "Choose",
  textTransform = "capitalize",
  isSkipped,
  isRegular
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
  return (<React.Fragment
>
<button
  data-testid="Repeater.Repeater"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--mt-5-ZqRuWl': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--bc-1-ZqRuWl': isHovered ? "rgba(0,147,201, 0.05)" : isReminder ? "#f1f1f1" : "#fff",'--bc-2-ZqRuWl': isHovered ? "rgba(0,147,201, 0.83)" : "#f2f2f2",'--bs-3-ZqRuWl': isHovered ? "solid" : "solid",'--btlr-4-ZqRuWl': isHovered ? "5px" : "5px"}}
 className={`views-block ${styles.Repeater1}`}
>
<div
  data-testid="Repeater.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="Repeater.Text"
  data-view-path={viewPath}
 style={{'--c-6-ZqRuWl': isHovered ? "#323232" : "black"}}
 className={`views-text ${styles.Text}`}
>
{label}
</span>
<span
  data-testid="Repeater.Text:1"
  data-view-path={viewPath}
 style={{'--tt-7-ZqRuWl': textTransform,'--c-6-ZqRuWl': isHovered ? "rgba(0,147,201, 0.83)" : "#404040"}}
 className={`views-text ${styles.Text1}`}
>
{isSkipped ? "Question Skipped" : text}
</span>
</div>
<fromFlow.When is={isRegular}>
<Check
  viewPath={`${viewPath}/Check`}
 height={25}
 marginLeft={15}
 marginRight={10}
 stroke="#0093c9"
 width={25}
/>
</fromFlow.When>
<fromFlow.When is={isSkipped}>
<ArrowsDown
  viewPath={`${viewPath}/ArrowsDown`}
 height={25}
 marginLeft={15}
 marginRight={10}
 stroke="#0093c9"
 width={25}
/>
</fromFlow.When>
<fromFlow.When is={isReminder}>
<ArrowRight
  viewPath={`${viewPath}/ArrowRight`}
 height={20}
 marginLeft={15}
 marginRight={10}
 stroke="#636363"
 width={20}
/>
</fromFlow.When>
</button>
{children}
</React.Fragment>)
}